module.exports = __webpack_public_path__ + "static/media/Centaur Warrior.8a586f1f.jpg";